import {gateway} from '../../api';

const CORE = process.env.REACT_APP_CORE;
export const getCentroCusto = () => (
  gateway.get(`${CORE}/centros-custo`)
);
